import React, { useEffect, useState } from 'react';
import { Navbar } from '../../components/Navbar';
import { Footer } from '../../components/Footer';
import { MegaphoneIcon, ArrowRightIcon } from 'lucide-react';
export const MarketingStrategyPage = () => {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className="w-full bg-gray-50 dark:bg-[#0A1C1A] min-h-screen" data-id="element-4717">
      <Navbar scrolled={scrolled} data-id="element-4718" />
      <main className="pt-24 pb-20" data-id="element-4719">
        <div className="container mx-auto px-4 md:px-6" data-id="element-4720">
          <div className="max-w-4xl mx-auto" data-id="element-4721">
            {/* Header */}
            <div className="bg-gradient-to-r from-[#0D3C45] to-[#2DB489] dark:from-[#2DB489] dark:to-[#4ED1A0] rounded-xl p-8 md:p-12 mb-12 text-white relative overflow-hidden" data-id="element-4722">
              <div className="absolute right-0 bottom-0 opacity-10" data-id="element-4723">
                <MegaphoneIcon className="h-64 w-64" data-id="element-4724" />
              </div>
              <div className="relative z-10" data-id="element-4725">
                <h1 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-4726">
                  How to Market Your Digital Products Effectively
                </h1>
                <p className="text-xl opacity-90 max-w-3xl" data-id="element-4727">
                  Learn practical strategies to promote your products using
                  social media, content, and targeted outreach to reach the
                  right audience and drive consistent sales.
                </p>
              </div>
            </div>
            {/* Main content */}
            <div className="bg-white dark:bg-[#162825] rounded-xl p-8 md:p-10 shadow-sm mb-10" data-id="element-4728">
              <p className="text-gray-600 dark:text-[#B0C1BD] mb-6 text-lg leading-relaxed" data-id="element-4729">
                Marketing your digital product is just as important as building
                it. Even the best product won't sell if people don't know it
                exists.
              </p>
              <p className="text-gray-600 dark:text-[#B0C1BD] mb-6 text-lg leading-relaxed" data-id="element-4730">
                Start by identifying your target audience. Understand who your
                product is for and where those people spend their time online.
                This helps you focus your efforts instead of trying to reach
                everyone.
              </p>
              <p className="text-gray-600 dark:text-[#B0C1BD] mb-6 text-lg leading-relaxed" data-id="element-4731">
                Use simple and consistent channels. Social media platforms,
                email newsletters, and online communities are great starting
                points. You don't need to be everywhere — focus on one or two
                platforms and do them well.
              </p>
              <p className="text-gray-600 dark:text-[#B0C1BD] mb-6 text-lg leading-relaxed" data-id="element-4732">
                Content plays a major role in marketing. Share insights, tips,
                or examples related to your product. This builds trust and
                positions you as someone who understands the problem you're
                solving.
              </p>
              <p className="text-gray-600 dark:text-[#B0C1BD] mb-6 text-lg leading-relaxed" data-id="element-4733">
                Consistency is key. Posting once won't bring results. Regular
                updates, even small ones, help keep your product visible and
                build long-term interest.
              </p>
              <p className="text-gray-600 dark:text-[#B0C1BD] mb-6 text-lg leading-relaxed" data-id="element-4734">
                Finally, make it easy for people to understand what you're
                offering. Clear messaging, simple explanations, and a clean
                product page all support your marketing efforts and increase
                conversions.
              </p>
            </div>
            {/* Related resources */}
            <div className="bg-white dark:bg-[#162825] rounded-xl p-8 shadow-sm mb-10" data-id="element-4735">
              <h2 className="text-xl font-bold text-gray-800 dark:text-[#F8FAF9] mb-6" data-id="element-4736">
                Related Resources
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-4737">
                <a href="/learn/building-audience" className="group block bg-gray-50 dark:bg-[#1A3330] rounded-lg p-5 transition-all hover:shadow-md" data-id="element-4738">
                  <h3 className="font-semibold text-gray-800 dark:text-[#F8FAF9] mb-2 group-hover:text-[#2DB489] dark:group-hover:text-[#4ED1A0] transition-colors" data-id="element-4739">
                    Building an Audience Before You Launch
                  </h3>
                  <p className="text-sm text-gray-600 dark:text-[#B0C1BD] mb-3" data-id="element-4740">
                    Discover how to grow an engaged audience before releasing
                    your product.
                  </p>
                  <div className="flex items-center text-[#2DB489] dark:text-[#4ED1A0] text-sm font-medium" data-id="element-4741">
                    <span data-id="element-4742">Read more</span>
                    <ArrowRightIcon className="ml-1 h-4 w-4 transform group-hover:translate-x-1 transition-transform" data-id="element-4743" />
                  </div>
                </a>
                <a href="/learn/pricing-strategies" className="group block bg-gray-50 dark:bg-[#1A3330] rounded-lg p-5 transition-all hover:shadow-md" data-id="element-4744">
                  <h3 className="font-semibold text-gray-800 dark:text-[#F8FAF9] mb-2 group-hover:text-[#2DB489] dark:group-hover:text-[#4ED1A0] transition-colors" data-id="element-4745">
                    How to Price Your Digital Products
                  </h3>
                  <p className="text-sm text-gray-600 dark:text-[#B0C1BD] mb-3" data-id="element-4746">
                    Learn how to choose the right pricing strategy based on
                    value and competition.
                  </p>
                  <div className="flex items-center text-[#2DB489] dark:text-[#4ED1A0] text-sm font-medium" data-id="element-4747">
                    <span data-id="element-4748">Read more</span>
                    <ArrowRightIcon className="ml-1 h-4 w-4 transform group-hover:translate-x-1 transition-transform" data-id="element-4749" />
                  </div>
                </a>
              </div>
            </div>
            {/* CTA */}
            <div className="bg-gradient-to-r from-[#0D3C45] to-[#2DB489] dark:from-[#2DB489] dark:to-[#4ED1A0] rounded-xl p-8 text-white text-center" data-id="element-4750">
              <h2 className="text-2xl font-bold mb-4" data-id="element-4751">
                Ready to market your digital products?
              </h2>
              <p className="text-lg opacity-90 mb-6 max-w-2xl mx-auto" data-id="element-4752">
                Apply these strategies and start reaching the right audience
                today.
              </p>
              <a href="/sell-product" className="inline-block bg-white text-[#0D3C45] px-6 py-3 rounded-lg font-medium hover:bg-opacity-90 transition-all" data-id="element-4753">
                Start Selling
              </a>
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-4754" />
    </div>;
};